import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from 'photoswipe/lightbox'

export default class extends Controller {
  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: 'a',
      pswpModule: () => import('photoswipe')
    })

    // Dynamically load image dimensions to preserve aspect ratio
    this.lightbox.addFilter('itemData', (itemData, index) => {
      const img = new Image()
      img.src = itemData.src

      if (img.complete) {
        itemData.width = img.naturalWidth
        itemData.height = img.naturalHeight
      } else {
        itemData.width = 1200
        itemData.height = 1200
      }

      return itemData
    })

    // Update dimensions once image loads
    this.lightbox.on('contentLoad', (e) => {
      const { content } = e
      if (content.type === 'image') {
        const img = content.element
        if (img) {
          img.onload = () => {
            content.width = img.naturalWidth
            content.height = img.naturalHeight
            content.instance.updateSize(true)
          }
        }
      }
    })

    this.lightbox.init()
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  }
}
